import { useEffect } from "react";
import "./ExecutiveDashBoard.scss";
import { useNavigate } from "react-router";
import { useAuthContext } from "../Context/AuthContext";
import TableauDashboardComponent from "../components/ExecutiveDashboard/TableauDashboardComponent";

function TableauDashboard() {
  const { isAuthenticated, appUser } = useAuthContext();
  const navigate = useNavigate();
  useEffect(() => {
    if (appUser && !isAuthenticated) {
      navigate(`/unauthorized`);
    }
  }, [isAuthenticated, appUser])

  return (
    <>
      <TableauDashboardComponent />
    </>
  );
}

export default TableauDashboard;
